import styles from './Grid.module.scss';
import { CSSProperties, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  columns?: number[];
}

export function Grid({ children, columns }: Props) {
  const style: CSSProperties | undefined =
    columns && columns.length > 0
      ? {
          gridTemplateColumns: columns.map((column) => column + 'fr').join(' '),
        }
      : undefined;

  return (
    <div className={styles['grid']} style={style}>
      {children}
    </div>
  );
}
